import { useState } from "react";
import { usePodcastProvider } from "components/podcast/PodcastProvider";
import { Player } from "react-media-player";
import { CustomPlayPause, CustomVolumeSlider } from "components/podcast/CustomMediaPlayer";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { Flex, Modal, ModalOverlay, ModalContent, ModalBody, IconButton, Button, Box, useDisclosure, Text } from "@chakra-ui/react";
import { CloseIcon, ExpandIcon, VolumeIcon } from "components/icons";
import PodcastColorTypes from "types/podcastColorTypes";

interface ExpandedScreenModalProps {
  playerSrc: string;
}

export function ExpandedScreenModal({ playerSrc }: ExpandedScreenModalProps) {
  const { isOpen, onOpen: onOpenExpandedScreenModal, onClose: closeExpandedScreenModal } = useDisclosure();
  const { playingPodcast, setExpandedScreenModal, expandedScreenModal, onClose, setPlayPodcast, setModalType, setPlayingPodcast } = usePodcastProvider();
  const [showVolume, setShowVolume] = useState<boolean>(false);

  const handleModalClose = () => {
    closeExpandedScreenModal();
    setExpandedScreenModal(false);
    setPlayingPodcast(null);
    setPlayPodcast(false);
    setModalType(null);
    onClose();
  };

  const handleModalOpen = () => {
    setExpandedScreenModal(true);
    onOpenExpandedScreenModal();
  };

  return (
    <Flex fontFamily="sora">
      <Button
        onClick={handleModalOpen}
        bgColor="transparent"
        width="48px"
        height="48px"
        color="white"
        _hover={{ bg: "transparent", color: "purple.50" }}
        _focus={{ outline: "none", bg: "transparent" }}
        mt="10px"
      >
        <ExpandIcon width="48px" height="48px" />
      </Button>
      <Modal onClose={handleModalClose} size="full" isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent margin="0px" overflow="hidden">
          <ModalBody padding="0px" zIndex="50">
            <Flex position="relative" zIndex="100">
              {expandedScreenModal && (
                <Player src={playerSrc} vendor="video" style={{ height: "80vh", minWidth: "100vw", width: "100vw", objectFit: "cover" }} autoPlay={true} className="media-player"></Player>
              )}
              <Flex position="absolute" width="100%" height="100%" flexDir="column" justifyContent="space-between">
                <Flex width="100%" height="48px" justifyContent="flex-end" padding="24px">
                  <IconButton
                    icon={<CloseIcon width="48px" height="48px" />}
                    width="24px"
                    aria-label="close-modal"
                    bg="transparent"
                    borderRadius="24px"
                    _hover={{ bg: "transparent", color: "purple.50" }}
                    color="white"
                    onClick={handleModalClose}
                  />
                </Flex>
                <Flex width="100%" padding="24px" justifyContent="space-between" alignItems="flex-end">
                  <CustomPlayPause size="32px" expandedPlay={true} />
                  <Box>
                    {showVolume && <CustomVolumeSlider volumeSliderHeight="32" />}
                    <Button
                      bgColor="transparent"
                      width="48px"
                      height="48px"
                      color="white"
                      _hover={{ bg: "transparent", color: "purple.50" }}
                      _focus={{ outline: "none", bg: "transparent" }}
                      mt="15px"
                      onClick={() => setShowVolume(!showVolume)}
                    >
                      <VolumeIcon width="48px" height="48px" />
                    </Button>
                  </Box>
                </Flex>
              </Flex>
            </Flex>
            <Flex bgColor="purple.150" padding="14px 24px 91px" height="20vh">
              <Flex flexDir="column" maxWidth="1320px" margin="auto" width="100%">
                <Flex justifyContent="space-between" mb="9px" alignItems="center">
                  <Text as="h5" fontSize="32px" lineHeight="40px" fontWeight="600" color="purple.50" display={{ base: "none", md: "flex" }}>
                    {playingPodcast?.title}
                  </Text>
                  <Flex
                    px="8px"
                    py="4px"
                    bg="green.50"
                    lineHeight="16px"
                    letterSpacing="0.01em"
                    fontSize="12px"
                    color={getPodcastThemeToken(PodcastColorTypes.EpisodeModalText)}
                    bgColor={getPodcastThemeToken(PodcastColorTypes.EpisodeModalBadgeOne)}
                    borderRadius="8px"
                  >
                    Episode {playingPodcast?.episode_number}
                  </Flex>
                </Flex>
                <Text fontSize="16px" lineHeight="20px" color="#4A4A4A">
                  {playingPodcast?.description}
                </Text>
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
}
